// eslint-disable-next-line @typescript-eslint/no-var-requires
const { getEntryFromURL } = require("./getEntry");

export const ENTRY: "mm" | "engage" | "cop" = getEntryFromURL();
